const shareLinkMergeTags = {
  'This Page': [
    {
      "featured": true,
      "slug": "page.url",
      "label": "This Page URL",
      "description": "The URL of this page"
    },
    {
      "featured": true,
      "slug": "page.whatsapp_share_url",
      "label": "This Page WhatsApp Share URL",
      "description": "The URL to share this page on WhatsApp"
    },
    {
      "featured": true,
      "slug": "page.facebook_share_url",
      "label": "This Page Facebook Share URL",
      "description": "The URL to share this page on Facebook"
    },
    {
      "featured": true,
      "slug": "page.twitter_share_url",
      "label": "This Page Twitter Share URL",
      "description": "The URL to share this page on Twitter"
    },
    {
      "featured": true,
      "slug": "page.linkedin_share_url",
      "label": "This Page LinkedIn Share URL",
      "description": "The URL to share this page on LinkedIn"
    },
    {
      "featured": true,
      "slug": "page.bluesky_share_url",
      "label": "This Page Bluesky Share URL",
      "description": "The URL to share this page on Bluesky"
    }
  ]
}

export default shareLinkMergeTags
